// extracted by mini-css-extract-plugin
export default {"bottom_affix":"index_bottom_affix_o6I0G","toTop_affix":"index_toTop_affix_8CUgN","backToTop":"index_backToTop_Acu11"};